import { HttpRequest } from "@/shared/request";
import {
    CMSAPI,
    FP_GET_STORE,
    FP_CREATE_STORE,
    FP_UPDATE_STORE,
} from "@/config/api";
import { TStore } from "@/shared/types";
import {
    GetDiageoCountryCode,
    GetLocale,
    GetSessionStorageItem,
    removeZeroWidthCharacters,
    SetSessionStorageItem,
} from "@/shared/utils";
export const GetFpSiteName = (id: string) => {
    return GetLocale() + "_" + id;
}
// client
export const storeProductsToFp = async (storeConfig: TStore, isSecondSite = false) => {
    SetSessionStorageItem("storeConfig", storeConfig, GetFpSiteName(storeConfig.id));
    if (location.pathname.includes("/error")) return;
    if (!isSecondSite) {
        if (sessionStorage.getItem("fp_init") === "true") return;
    }
    const { cocktailList, secondSitename, id } = storeConfig;
    const {
        cocktailList: secondCocktailList, id: secondSiteNameId
    } = secondSitename || { id: '', cocktailList: [] }
    const storeName = GetFpSiteName(isSecondSite ? secondSiteNameId : id);
    const fpData = await getFpSourceData(storeName);
    const cmsProducts = (isSecondSite ? secondCocktailList : cocktailList)?.map((item) =>
        removeZeroWidthCharacters(item?.cocktailID.name)
    ).filter((item) => item);
    if (!cmsProducts || cmsProducts.length === 0) return;
    
    if (fpData.length > 0) {
        const isEqualIds = isEqualArrayUnique(fpData, cmsProducts);
        if (!isEqualIds) {
            SyncFpStore(`${FP_UPDATE_STORE}`, {
                siteId: storeName,
                cocktails: cmsProducts,
            });
        } else {
            sessionStorage.setItem("fp_init", "true");
        }
    } else {
        SyncFpStore(`${FP_CREATE_STORE}`, {
            siteId: storeName,
            cocktails: cmsProducts,
        });
    }
};
const getFpSourceData = async (storeName: string): Promise<Array<string>> => {
    const res = await HttpRequest.get<{
        success: boolean;
        data: {
            cocktails: Array<{ cocktailId: string }>
        }
    }>(`${FP_GET_STORE}?siteId=${storeName}`);
    return res.data.success
        ? res.data.data.cocktails.map((item) => item.cocktailId.toLowerCase())
        : [];
};
const SyncFpStore = async (
    url: string,
    data: { siteId: string; cocktails: string[] },
    counter = 0
) => {
    const res = await HttpRequest.post<{
        success: boolean;
        cocktails: Array<string>
    }>(url, {
        siteId: data.siteId,
        cocktails: data.cocktails.map((item) => ({ cocktailId: item })),
        countryCode: GetDiageoCountryCode()
    });
    if (res.data.success) {
        sessionStorage.setItem("fp_init", "true");
    }
    if (!res.data.success) {
        sessionStorage.removeItem("fp_init");
        if (counter < 3) {
            SyncFpStore(url, data, counter + 1);
        } else {
            console.log("updateFpData error");
            window.location.href = `/${GetLocale()}/error?errorType=SyncFpStore`;
        }
    }
};

export const loadNewStoreConfig = async (
    locale: string,
    oldStoreConfig: TStore
) => {
    if (location.pathname.includes("/error")) return null;
    const cachedKey = `${locale}-${oldStoreConfig.id}`;
    const value = GetSessionStorageItem("storeConfig", cachedKey, 1000 * 60 * 30);
    if (value) return value;
    const storeRes = await HttpRequest.get<{
        success: boolean;
        data: Array<TStore>
    }>(
        `${CMSAPI}?locale=${locale}&contentType=storeList&noCache=true&title=${oldStoreConfig.id}`
    );
    if (storeRes.data.success) {
        const newData = storeRes.data.data.find((item) => item.id === oldStoreConfig.id && item.storeEnable)
        if (newData) {
            const differ = deepEqual(newData, oldStoreConfig);
            SetSessionStorageItem("storeConfig", differ ? newData : oldStoreConfig, cachedKey);
            return differ ? newData : null;
        } else {
            // store is enable or not found
            if (!location.pathname.includes("/error")) {
                location.href = `/${locale}/error`;
            } else {
                return null;
            }
        }
    }
    return null;
};
function deepEqual(obj1: any, obj2: any) {
    if (obj1 === obj2) {
        return true;
    }

    if (Number.isNaN(obj1) && Number.isNaN(obj2)) {
        return true;
    }

    if (obj1 == null || obj2 == null) {
        return obj1 === obj2;
    }

    const type1 = typeof obj1;
    const type2 = typeof obj2;

    if (type1 !== type2) {
        return false;
    }

    if (type1 !== 'object') {
        return obj1 === obj2;
    }

    const isArray1 = Array.isArray(obj1);
    const isArray2 = Array.isArray(obj2);

    if (isArray1 !== isArray2) {
        return false;
    }

    if (isArray1) {
        if (obj1.length !== obj2.length) {
            return false;
        }
        for (let i = 0; i < obj1.length; i++) {
            if (!deepEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
        return true;
    } else {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (!Object.hasOwn(obj2, key)) {
                return false;
            }
            if (!deepEqual(obj1[key], obj2[key])) {
                return false;
            }
        }

        return true;
    }
}

function isEqualArrayUnique(arr1: string[], arr2: string[]): boolean {
    const set1 = new Set(arr1.map(s => s.toLowerCase()));
    const set2 = new Set(arr2.map(s => s.toLowerCase()));
    return set1.size === set2.size && [...set1].every(item => set2.has(item));
}